export const MHE_AVAILABLE_TRANSLATION_LANGUAGES_BY_AI = ["en-EN","es-ES","ca-ES", "gl-ES"]


